.<template>
  <div class="">
    <van-popup v-model="showpop" position="bottom">
      <div class="kefu_pop pr">
        <p class="title">联系客服</p>
        <div class="close">
          <qdd-icon
            class="iconquxiao"
            color="#999"
            size="0.8rem"
            @click="showpop = false"
          ></qdd-icon>
        </div>
        <div class="kf_list flex_b" v-for="(item, idx) in kfList" :key="idx">
          <div class="kf_con flex">
            <img
              src="https://7dd-statics.oss-cn-beijing.aliyuncs.com/smallProgram/installMall/new_kf_img.png"
              alt
            />
            <div class="kf_name">
              <p>{{ item.custorm_name }}</p>
              <p class="mtp">{{ item.hide_customer_phone }}</p>
            </div>
          </div>
          <div class="tel">
            <a :href="`tel:${item.customer_phone}`" class="phone_point">拨打</a>
          </div>
        </div>
      </div>
    </van-popup>
    <!-- <div class="base_mod">
           
       </div> -->
  </div>
</template>

<script>
import { sendRequest } from "@/assets/public";
import icon from "@/components/iconfont";
export default {
  name: "newPicker",
  components: {
    "qdd-icon": icon,
  },
  // props: {
  //   showpop: {
  //     type: Boolean,
  //     default: false,
  //   },
  // },
  created() {
    this.getStoreCustormContact();
  },
  data() {
    return {
      kfList: [],
      showpop: false,
    };
  },
  methods: {
    showPopFg() {
      this.showpop = !this.showpop;
    },
    async getStoreCustormContact() {
      let res = await sendRequest("user/StoreCustormContact", { type: "0" });
      this.showLoading = false;
      if (res.status == 200) {
        this.kfList = res.content;
        this.$emit("custom-event", res.content.length);
      }
    },
  },
};
</script>

<style scoped>
.close {
  position: absolute;
  top: 0.4rem;
  right: 0.4rem;
}
.tel {
  padding: 0.2rem 0.6rem;
  background: #fff2f2;
  border-radius: 0.8rem;
  border: 1px solid #ffb5b0;
  text-align: center;
  font-weight: 400;
  font-size: 0.52;
  color: #ff463a;
}
.phone_point {
  font-weight: 400;
  font-size: 0.52;
  color: #ff463a;
}
.kf_name p {
  padding-left: 0.4rem;
  font-size: 0.52rem;
  color: #333;
}
.mtp {
  margin-top: 0.2rem;
}
.kf_con {
  align-items: center;
}
.kf_con img {
  width: 1.6rem;
  height: 1.6rem;
}
.flex {
  display: flex;
}
.flex_b {
  display: flex;
  justify-content: space-between;
}
.flex_a {
  display: flex;
  justify-content: space-around;
}
.kf_list {
  width: 12.8rem;
  padding: 0 0.5rem;
  height: 2.8rem;
  padding: 0 20rpx;
  background: #fff5f4;
  border-radius: 0.3rem;
  border: 1px solid #ffdcd9;
  margin: 0 auto 0.4rem;
  align-items: center;
}
.base_mod {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.8);
  z-index: 10000;
}
.pr {
  position: relative;
}
.kefu_pop {
  width: 100%;
  position: fixed;
  bottom: 0;
  left: 0;
  border-radius: 0.6rem 0.6rem 0 0;
  background: #fff;
  z-index: 10000;
}
.kefu_pop .title {
  text-align: center;
  font-size: 0.5rem;
  padding: 0.6rem 0 0.4rem 0;
  font-weight: 600;
}
</style>